import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { StylesProvider } from '@material-ui/core/styles';
import ErrorBoundary from 'components/ErrorBoundary';
import Loader from 'components/Loader';
import ScrollToTop from 'components/ScrollToTop';
import Toaster from 'components/Toaster';
import { initialize as initializeDatadog } from 'helper/datadog';
import { GoogleConversionTracker } from 'providers';
import HubSpotTrackerScript from 'providers/HubSpotTracker';
import { PersistGate } from 'redux-persist/integration/react';
import Routes from 'route/route';

import initStore from 'redux/store';

import './index.css';

import reportWebVitals from './reportWebVitals';

const { store, persistor } = initStore;

initializeDatadog();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
                <GoogleConversionTracker />
                <HubSpotTrackerScript />
                <StylesProvider injectFirst>
                    <BrowserRouter>
                        <ScrollToTop>
                            <Routes />
                        </ScrollToTop>
                        <Loader />
                        <Toaster />
                    </BrowserRouter>
                </StylesProvider>
                <ToastContainer />
            </ErrorBoundary>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
